import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-testemail',
  templateUrl: './testemail.component.html',
  styleUrls: ['./testemail.component.css']
})
export class TestemailComponent implements OnInit {

  public email:string="";
  public subject:string="";
  public message:string="";
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<TestemailComponent>) { 
       
  }

  ngOnInit() {
  }

  SendEmails()
  {
    this.dialogRef.close({email:this.email, subject:this.subject, message:this.message});
  }

  Close()
  {
    this.dialogRef.close();
  }
}
